<template lang="pug">
  v-layout(row)
    v-flex(xs4) {{order.data.name}}
    v-flex(xs5) {{event.eventName}}
    v-flex(xs3) ${{totalCost}} TT
</template>
<script>
export default {
  name:"Order",
  props:['order'],
  computed:{
    totalCost(){
      let total = 0
      if (this.order.data.packages){
        this.order.data.packages.forEach(p=>{
          total += p.cost * p.amount
        })
      }
      if(this.order.data.items){
        this.order.data.items.forEach(i=>{
          total += i.cost * i.amount
        })
      }
      if(this.order.data.convenienceFee){
        total += this.order.data.convenienceFee
      }
      return total
    },
    event(){
      return this.$store.state.events.filter(e=>{
        return e.id == this.order.data.selectedEvent
      })[0]
    }
  }

}
</script>
